var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-login" },
    [
      _c("sweet-modal", { ref: "modal", attrs: { "overlay-theme": "dark" } }, [
        _c("h3", [
          _vm._v(
            _vm._s(_vm.$t("message.login.confirm_email_to_activate_account"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.loginData.email,
                expression: "loginData.email"
              }
            ],
            ref: "email",
            staticClass: "form-control input-lg",
            attrs: {
              type: "email",
              placeholder: _vm.$t("message.login.email")
            },
            domProps: { value: _vm.loginData.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.loginData, "email", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "button-large button-block -cyan",
              attrs: { disabled: _vm.isLoggingIn },
              on: { click: _vm.loginApp }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.isLoggingIn
                      ? _vm.$t("message.button.loading")
                      : _vm.$t("message.button.login")
                  ) +
                  "\n      "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4b99f8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4b99f8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/RequestEmailModal.vue
// module id = 1451
// module chunks = 0